import React from 'react';
import PageDetail from './PageDetail';

const OurDayDetail = (props) => {
  return <PageDetail tag='DAY' url='/our-day' id={props.match.params.id}/>;
}

export default OurDayDetail;